import { Chip } from '@/shared/ui';

type StationChipProps = {
	type: 'cheapest' | 'nearest';
};

const StationChip = ({ type }: StationChipProps) => {
	return (
		<Chip
			className={`${type === 'cheapest' ? 'bg-[#FAE3E1] text-[#FC494D]' : 'bg-[#E1F4E8] text-[#41915E]'}`}
		>
			{type === 'cheapest' ? '최저가' : '가까워요'}
		</Chip>
	);
};

export default StationChip;
